var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"form-comment"},[_vm._t("default"),_c('VText',{attrs:{"small":""},domProps:{"innerHTML":_vm._s(_vm.value)}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }